import { action, get, put, del } from '@/lib/api.js';
import getCompanyIdForRequest from '@/lib/getCompanyIdForRequest';

export const logoutAndRedirect = () => {
  action('LOGOUT');
  [...Object.keys(localStorage)]
    .filter((n) => n.match(/^persist:/))
    .filter((n) => n !== 'persist:appReducer')
    .forEach((n) => localStorage.removeItem(n));
  if (window.location.pathname !== '/login') {
    window.location.href = '/login';
  }
};

export const addRecentAction = (item) => {
  action('ADD_RECENT_ACTION', { item });
};

export const getUserCompanies = ({ userId, search, cancelRef, callback }) => {
  return get(`v1/users/${userId}/companies`, {
    query: { search },
    cancelRef,
    callback,
    action: 'GET_USER_COMPANIES',
    loader: 'getUserCompanies'
  });
};

export const getUserCompaniesOptions = ({ userId, search, includeUserSearch, recentCompanyIds, cancelRef, callback }) => {
  return get(`v1/users/${userId}/companies/options`, {
    query: { search, includeUserSearch, recentCompanyIds },
    cancelRef,
    callback,
    action: 'GET_USER_COMPANIES_OPTIONS',
    loader: 'getUserCompaniesOptions'
  });
};

export const searchCommandBar = ({ q, cancelRef }) => {
  return get(`v1/command-bar/search`, {
    query: { q },
    action: 'SEARCH_COMMAND_BAR',
    loader: 'searchCommandBar',
    cancelRef
  });
};

export const getUserState = ({ userId }, callback) => {
  const companyId = getCompanyIdForRequest();
  return get(`v1/users/${userId}/state`, {
    query: {},
    headers: { 'X-Company-Id': companyId || '' },
    meta: { userId, companyId },
    action: 'GET_USER_STATE',
    loader: 'getUserState',
    callback
  });
};

export const getOrgState = (callback) => {
  return get(`v1/companies/state`, {
    action: 'GET_ORG_STATE',
    loader: 'getOrgState',
    callback
  });
};

export const getUserSettings = () => {
  return get(`v1/users/settings`, {
    action: 'GET_USER_SETTINGS'
  });
};

export const putUserSettings = ({ alertEmail, alerts }) => {
  return put(`v1/users/settings`, {
    data: {
      alertEmail,
      alerts
    },
    action: 'GET_USER_SETTINGS'
  });
};

export const putUserCompany = ({ userId, companyId }, callback) => {
  return put(`v1/users/${userId}/companies/${companyId}`, {
    data: { companyId },
    callback
  });
};

export const getObjectCompany = async ({ objectType, objectId }, callback) => {
  return get('v1/auth/object-company', {
    query: {
      objectType,
      objectId
    },
    action: 'GET_OBJECT_COMPANY',
    callback
  });
};

export const deleteUser = ({ userId }) => {
  return del(`v1/users/${userId}`, {
    action: 'DELETE_USER',
    meta: { userId }
  });
};

export const deleteSignupUser = ({ userId }) => {
  return del(`v1/users/${userId}/signup`, {
    action: 'DELETE_SIGNUP_USER',
    meta: { userId }
  });
};

export const getUserIdentity = ({ userId }) => {
  return get(`v1/users/${userId}/identity`, {
    action: 'GET_USER_IDENTITY',
    meta: { userId }
  });
};
